import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeAnnexeATA } from '../models/TypeAnnexeATA';
import { TypeAdresseComplete } from '../models/TypeAdresseComplete';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
import { Step12 } from '../../../../shared/models/component-messages/mapaIN/step12';
@Component({
  selector: 'app-type-annexeATA',
  templateUrl: './type-annexeATA.component.html'
})
export class TypeAnnexeATAComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeAnnexeATA';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() admOuTech: TypeAnnexeATA;
  @Input() admOuTechSelect = '';
  public step12 = new Step12();

  constructor() { }

  public ngOnInit() {
  }
  
  addtypeAdresseCompleteAdm(){
    if(!this.admOuTech) {
      this.admOuTech = new TypeAnnexeATA();
    }
    if (!this.admOuTech.adm) {
      this.admOuTech.adm = [];
    }
		this.admOuTech?.adm.push(new TypeAdresseComplete());
	}
  
  removetypeAdresseCompleteAdm(i){
    ArrayPopTools.pop(this.admOuTech.adm, i, this.parentForm, 'adm' + this.getUid());
	}
  
  addtypeAdresseCompleteTech(){
    if(!this.admOuTech) {
      this.admOuTech = new TypeAnnexeATA();
    }
    if (!this.admOuTech.tech) {
      this.admOuTech.tech = [];
    }
		this.admOuTech?.tech.push(new TypeAdresseComplete());
	}
  
  removetypeAdresseCompleteTech(i){
    ArrayPopTools.pop(this.admOuTech.tech, i, this.parentForm, 'tech' + this.getUid());
	}

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
